// Public URL of the device-facing kiosk app, per environment. Prod builds set
// REACT_APP_ENVIRONMENT="production" (see src/firebase/config.js); everything else
// is UAT. Shown to admins so they know where to open the kiosk app on a device to
// pair it — and so the hint is never misleading between environments.
export const KIOSK_APP_URL =
  process.env.REACT_APP_ENVIRONMENT === "production"
    ? "https://kiosk.sahod.solutions"
    : "https://sahod-kiosk-uat.web.app";

// Host without the scheme, for display (e.g. "kiosk.sahod.solutions").
export const KIOSK_APP_HOST = KIOSK_APP_URL.replace(/^https?:\/\//, "");
